import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import { appBasename, appSurface, surfaceOwnsRouter } from './surface';

const root = document.getElementById('root');
if (!root) {
  throw new Error('missing #root');
}

const surface = appSurface();

// Get Hired owns createBrowserRouter + RouterProvider; nesting BrowserRouter breaks it.
// No StrictMode: docs/admin legacy clients attach once to the DOM.
if (surfaceOwnsRouter(surface)) {
  createRoot(root).render(<App />);
} else {
  createRoot(root).render(
    <BrowserRouter basename={appBasename(surface)}>
      <App />
    </BrowserRouter>,
  );
}
